import { CheckListDetailsItemValuesInterface } from '@modals/check-list-details/interfaces/check-list-details-item-values.interface';
import { CheckListDetailsTableRowInterface } from '@modals/check-list-details/interfaces/check-list-details-table-row.interface';

/**
 * Reads the current item values from a table row for the save payload.
 *
 * @param row - checklist table row
 */
export function getCheckListDetailsItemValuesFromRow(row: CheckListDetailsTableRowInterface): CheckListDetailsItemValuesInterface {
  return {
    createdBy: row.createdBy,
    createdOn: row.createdOn,
    isChecked: row.isCheckedControl.getRawValue(),
    lastUpdatedBy: row.lastUpdatedBy,
    lastUpdatedByName: row.lastUpdatedByName,
    lastUpdatedOn: row.lastUpdatedOn,
  };
}
